import client from '../../base-api';

const serviceURL = '/case-management-coaching-overview';

const overviewSocioTherapyCoachingService = {
    getNewAndActiveList(filterData: any) {
        return client.get(`${serviceURL}/new-and-active`, {params: filterData});
    },
    getFinishedList(filterData: any) {
        return client.get(`${serviceURL}/finished`, {params: filterData});
    },
    getArchivedList(filterData: any) {
        return client.get(`${serviceURL}/archived`, {params: filterData});
    },

}
export default overviewSocioTherapyCoachingService;